'use strict';

angular.module('ClinicApp')
  .controller(
    'TrackedModalWrapperControl',
    function(
      $scope,
      $modalInstance,
      UserService,
      CurrentUser,
      clinic,
      modalName,
      bodyTemplateUrl,
      onClickToAdvance,
      customResolve,
      showCloseButton,
    ) {
      $scope.clinic = clinic;
      $scope.bodyTemplateUrl = bodyTemplateUrl;
      $scope.showCloseButton = showCloseButton;

      Object.entries(customResolve)
        .forEach(([key, value]) => $scope[key] = value);

      // Record when this modal was viewed
      UserService.trackModalShown({
        modalName,
      });

      $scope.close = () => $modalInstance.dismiss('cancel');

      $scope.loading = false;

      $scope.advance = () => {
        if ($scope.loading) {
          return;
        }

        $scope.loading = true;

        // Record when the CTA was clicked for this one-time modal
        // except if we're impersonated in prod or the user will never see it!
        const promise = CurrentUser.isImpersonatedInProd()
          ? Promise.resolve()
          : UserService.trackModalCta({
            modalName,
          });

        promise.then(() => {
          $scope.loading = false;

          onClickToAdvance?.($scope);
          $modalInstance.close();
        });
      };
    },
  );
